<template>
  <main-layout>
    <div style="position:relative" v-resize="onResize">
      <div
        class="text-xs-right"
        style="overflow-x: auto;white-space: nowrap;position: absolute;border-bottom: 1px solid #F5F4F4; background: #F5F4F499; top: 0;left: 0;right: 0; z-index: 2"
      >
        <v-layout>
          <v-flex shrink>
            <v-btn
              small
              fab
              outline
              class="mt-3"
              v-if="selectedFlow && showFlow"
              @click="
                $store.dispatch('setFlowID', null)
                showFlow = false
                intents = null
              "
              ><v-icon>arrow_back</v-icon></v-btn
            >
          </v-flex>
          <template v-if="selectedFlow && showFlow">
            <v-flex shrink>
              <v-chip color="warning" class="mt-3 white--text" disabled
                >{{ selectedFlow.flowname }}
                <v-icon small class="ml-2" v-if="!check_privilage">lock</v-icon>
              </v-chip>
            </v-flex>
            <v-flex style="max-width: 400px">
              <v-text-field
                dense
                label="Search Node"
                id="searchNode"
                v-model="search"
                single-line
                hide-details
                prepend-inner-icon="search"
              ></v-text-field>
            </v-flex>
          </template>
          <template v-else>
            <!-- <v-flex style="max-width: 400px" class="pl-2">
              <v-text-field
                dense
                label="Search Flow"
                id="searchFlow"
                single-line
                v-model="searchFlow"
                hide-details
                prepend-inner-icon="search"
              ></v-text-field>
            </v-flex> -->
          </template>

          <v-flex>
            <v-dialog v-model="showVariable" width="1000">
              <template v-slot:activator="{ on }">
                <v-btn
                  outline
                  color="primary"
                  v-on="on"
                  class="hidden-xs-only mt-3"
                  :loading="loadingVariableList"
                  :disabled="!selectedFlow"
                >
                  <v-icon class="mr-2">edit</v-icon>
                  <span>Local Variable</span>
                </v-btn>
                <v-btn
                  outline
                  color="primary"
                  v-on="on"
                  small
                  fab
                  class="hidden-sm-and-up mt-3"
                  :loading="loadingVariableList"
                  :disabled="!selectedFlow"
                  ><v-icon small>edit</v-icon></v-btn
                >
              </template>
              <v-card>
                <div class="text-xs-right">
                  <v-btn flat fab small @click="showVariable = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <local-variable-setting
                  v-if="!loadingVariableList && selectedFlow"
                ></local-variable-setting>
              </v-card>
            </v-dialog>
            <v-dialog v-model="showSetting" width="1000">
              <template v-slot:activator="{ on }">
                <v-btn outline color="primary" v-on="on" class="hidden-xs-only mt-3">
                  <v-icon class="mr-2">settings_applications</v-icon>
                  <span>setting</span>
                </v-btn>

                <v-btn outline color="primary" v-on="on" small fab class="hidden-sm-and-up mt-3"
                  ><v-icon small>settings_applications</v-icon></v-btn
                >
              </template>
              <v-card>
                <div class="text-xs-right">
                  <v-btn fab flat small @click="showSetting = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <v-tabs fixed-tabs v-model="settingTab">
                  <v-tab :key="'globalvariable'" :href="'#globalvariable'">Global Variable</v-tab>
                  <v-tab :key="'api'" :href="'#api'">API</v-tab>
                  <v-tab :key="'flow'" :href="'#flow'">Flow</v-tab>
                  <v-tab :key="'export'" :href="'#export'">Export</v-tab>
                </v-tabs>

                <div v-if="settingTab == 'globalvariable'">
                  <global-variable-setting v-if="!loadingFlowList"></global-variable-setting>
                </div>
                <div v-if="settingTab == 'localvariable'"></div>
                <div v-if="settingTab == 'api'">
                  <api-setting></api-setting>
                </div>
                <div v-if="settingTab == 'flow'">
                  <flow-setting></flow-setting>
                </div>
                <div v-if="settingTab == 'export'">
                  <v-container>
                    <div class="text-xs-center">
                      Import flow
                    </div>
                    <v-layout>
                      <v-flex class="pa-1">
                        <v-btn
                          block
                          color="primary"
                          depressed
                          @click="onClickUploadButton"
                          :disabled="!intents"
                          :loading="loadingExport"
                        >
                          Import
                        </v-btn>
                      </v-flex>
                      <v-flex class="pa-1">
                        <v-btn
                          block
                          color="primary"
                          depressed
                          @click="exportFlow"
                          :disabled="!intents"
                          :loading="loadingExport"
                        >
                          Export
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </div>
      <!-- <div
        class="text-xs-center"
        style="overflow-x:hidden; overflow-y: auto;position: absolute; width: 80px;border-right: 1px solid #E2E2E2; background: #E2E2E299; top: 60px;left: 0; z-index: 2"
        :style="{ height: maxHeight + 'px' }"
      >
        <div class="flow pt-3 pb-3 pl-1 pr-1" @click="showAddFlow = true">
          <v-icon>add</v-icon>
          <div class="caption">Add Flow</div>
        </div>
        <template v-for="(flow, index) in filterFlows">
          <div
            class="flow pt-3 pb-3 pl-1 pr-1"
            :key="'flow_' + index"
            :class="{ active: selectedFlow && flow.id == selectedFlow.id }"
            @click="onClickFlow(flow)"
          >
            <v-icon :color="selectedFlow && flow.id == selectedFlow.id ? 'white' : ''"
              >account_tree</v-icon
            >
            <div class="caption">{{ flow.flowname }}</div>
          </div>
          <v-divider :key="'flow_divider_' + index"></v-divider>
        </template>
      </div> -->
      <template v-if="selectedFlow && showFlow">
        <flow
          v-model="selectedFlow"
          :key="selectedFlow.id"
          :search="search"
          @loadIntent="loadIntent"
        ></flow>
      </template>

      <div v-else class="pa-2">
        <div style="height: 70px"></div>
        <v-layout class="mb-3">
          <v-flex>
            <v-btn @click="showAddFlow = true" color="primary">
              <v-icon class="mr-2">
                create_new_folder
              </v-icon>
              <div>Add Flow</div>
            </v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-text-field
              style="max-width: 250px; margin-right: 0; margin-left: auto"
              name="search"
              label="Search"
              v-model="searchFlow"
              clearable
              single-line
              prepend-inner-icon="search"
              outline
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(template, index) in items"
              :key="`${index}_${template.name}`"
            >
              <template v-slot:header>
                <div>{{ template.name ? template.name : 'ไม่มี template' }}</div>
              </template>
              <v-card>
                <v-card-text>
                  <v-layout wrap>
                    <template v-for="flow in template.children">
                      <v-flex
                        xs6
                        sm4
                        md3
                        lg2
                        xl1
                        class="px-2 py-3 flow"
                        :key="'flow_' + flow.id"
                        :class="{ active: selectedFlow && flow.id == selectedFlow.id }"
                        @click="onClickFlow(flow)"
                      >
                        <div class="text-xs-center" style="word-break: break-all;">
                          <v-badge :value="flow.ispublic == true" overlap color="green">
                            <template v-slot:badge>
                              <v-icon dark small>
                                public
                              </v-icon>
                            </template>
                            <v-icon x-large>
                              folder_open
                            </v-icon>
                          </v-badge>

                          <div class="caption">{{ flow.flowname }}</div>
                        </div>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- <template v-for="(flow, index) in filterFlows">
            <v-flex
              xs6
              sm4
              md3
              lg2
              xl1
              class="px-2 py-3 flow"
              :key="'flow_' + index"
              :class="{ active: selectedFlow && flow.id == selectedFlow.id }"
              @click="onClickFlow(flow)"
            >
              <div class="text-xs-center">
                <v-icon x-large>
                  folder_open
                </v-icon>
                <div class="caption">{{ flow.flowname }}</div>
              </div>
            </v-flex>
          </template> -->
        </v-layout>
      </div>
    </div>
    <v-dialog persistent v-model="showAddFlow" max-width="600">
      <v-card>
        <div class="text-xs-right">
          <v-btn
            fab
            flat
            small
            :loading="loadingAddFlow"
            @click="
              showAddFlow = false
              flowname = ''
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-text-field
            v-model="flowname"
            class="mb-2"
            label="Flow name"
            placeholder
            outline
            :data-vv-as="$t('Flow Name')"
            v-validate="'required'"
            name="flowname"
            :error-messages="errors.first('flowname')"
            :hide-details="!errors.has('flowname')"
          ></v-text-field>

          <template>
            <v-text-field
              v-model="flowtemplate"
              label="Flow Template"
              placeholder
              class="mb-2"
              outline
              :data-vv-as="$t('Flow Template')"
              name="flowtemplate"
              :error-messages="errors.first('flowtemplate')"
              :hide-details="!errors.has('flowtemplate')"
            ></v-text-field>
          </template>

          <v-textarea
            label="Description"
            name="description"
            v-model="description"
            placeholder
            outline
            :data-vv-as="$t('Description')"
            :error-messages="errors.first('description')"
            :hide-details="!errors.has('description')"
          ></v-textarea>

          <v-checkbox label="Share flow" v-model="isPublic" value="true"></v-checkbox>

          <div class="text-xs-center">
            <v-btn
              color="grey"
              :loading="loadingAddFlow"
              outline
              @click=";(showAddFlow = false), (flowname = '')"
              >{{ $t('cancel') }}</v-btn
            >
            <v-btn color="primary" :loading="loadingAddFlow" depressed @click="addNewFlow">{{
              $t('Save')
            }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <input
      type="file"
      class="form-control-file pt-2"
      name="fileUpload"
      :id="'fileUploadInput'"
      data-vv-as="File"
      v-validate="'size:10240|mimes:text/*'"
      accept=".text,.txt,.json,.JSON"
      @change="onFileChange($event)"
      style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;"
    />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import Flow from './Flow.vue'
import GlobalVariableSetting from './GlobalVariableSetting.vue'
import LocalVariableSetting from './LocalVariableSetting.vue'
import FlowSetting from './FlowSetting.vue'
import ApiSetting from './ApiSetting.vue'
import copyNodeMixin from '@/mixins/copyNodeMixin.js'
import flowMixin from '@/mixins/flowMixin'
import { cloneDeep } from 'lodash'

export default {
  mixins: [copyNodeMixin, flowMixin],
  props: {
    isEdit: {
      default: true
    }
  },
  data() {
    return {
      maxHeight: 3000,
      maxWidth: 3000,
      showSetting: false,
      settingTab: 'globalvariable',
      showVariable: false,
      showAddFlow: false,
      flowname: null,
      flowtemplate: null,
      loadingAddFlow: false,
      search: '',
      searchFlow: '',
      showFlow: false,
      description: '',
      intents: null,
      loadingExport: false,
      isPublic: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      loadingVariableList: 'getLoadingVariableList',
      variableList: 'getVariableList',
      selectedFlow: 'getFlowId'
    }),
    check_privilage() {
      if (!this.selectedFlow) return false
      if (!this.isEdit) return false
      return (
        this.$store.state.superadmin.includes(this.$store.state.userid) ||
        this.selectedFlow.createdby == this.$store.state.userid ||
        this.selectedFlow.owneradminid == this.$store.state.userid ||
        this.selectedFlow.isedit == true
      )
    },
    filterFlows() {
      if (this.searchFlow == '') return this.flows

      return this.flows.filter(el => {
        return el.flowname.toLowerCase().includes(this.searchFlow.toLowerCase())
      })
    },

    templateList() {
      var template = this.filterFlows
        .map(el => {
          if (el.template) return el.template.toLowerCase()
          else return null
        })
        .filter(Boolean)

      return [
        ...template
          .filter((v, i) => template && v && template.indexOf(v) === i)
          .sort((a, b) => {
            if (a < b) return -1
            else if (a > b) return 1
            else return 0
          }),
        null
      ]
    },
    items() {
      const children = this.templateList.map(type => ({
        id: type,
        name: this.getName(type),
        children: this.getChildren(type)
      }))

      return [...children]
    },
    localVariables() {
      if (!this.selectedFlow) {
        return []
      }
      try {
        return this.variableList.filter(el => {
          return el.flowid == this.selectedFlow.id
        })
      } catch (error) {
        return []
      }
    },
    globalVariables() {
      if (this.variableList) {
        let filter = this.variableList
          .filter(el => {
            return el.flowid == 0
          })
          .map(el => ({ ...el, pageid: this.selectedBot.pageid }))
        return filter
      } else {
        return []
      }
    }
  },
  components: {
    Flow,
    GlobalVariableSetting,
    LocalVariableSetting,
    FlowSetting,
    ApiSetting
  },
  async created() {},
  async mounted() {
    if (this.selectedBot.channel == 'facebook') {
      this.$store.dispatch('loadPersistentMenu', {
        pageid: this.selectedBot.pageid,
        isForceLoad: false
      })
    }

    this.$store.dispatch('loadSetting')
    this.$store.dispatch('loadApiList')
    this.$store.dispatch('loadAllVariable')
    this.$store.dispatch('loadAllAdmins')

    await this.$store.dispatch('loadFlowList')
    if (this.flows.length > 0) {
      if (this.$route.query.flowid) {
        var flow = this.flows.find(el => {
          return el.id == this.$route.query.flowid
        })
        if (flow) {
          this.$store.dispatch('setFlowID', flow)
          this.showFlow = true
        } else {
          // this.$store.dispatch('setFlowID', this.flows[0])
        }
      } else {
        // this.$store.dispatch('setFlowID', this.flows[0])
      }
    }
  },
  methods: {
    loadIntent(intents) {
      this.intents = intents
    },
    onClickUploadButton: function() {
      if (document.getElementById('fileUploadInput'))
        document.getElementById('fileUploadInput').click()
    },
    async onFileChange(event) {
      let vm = this
      let files = event.target.files || event.dataTransfer.files
      if (!files.length) return
      var fr = new FileReader()

      fr.onload = function(e) {
        var result = JSON.parse(e.target.result)
        if (result) vm.importFlow(result)
      }

      fr.readAsText(files[0])

      event.target.value = ''
    },
    async importFlow(data) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to transfer this?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      this.loadingExport = true

      let intents = data.flows || [],
        localVariables = data.localVariables || [],
        globalVariables = data.globalVariables || []
      if (result.value) {
        let insertIntentPromises = [],
          insertLocalVarPromises = [],
          insertGlobalVarPromises = []

        if (intents && intents.length > 0) {
          intents = intents.filter(node => {
            return node.type != 'start_node'
          })
          var newNodes = await this.getCopyNode(intents, this.selectedFlow.id)
          insertIntentPromises = newNodes.map(node => {
            return this.multipleUpdateNode(node)
          })

          if (insertIntentPromises.length > 0) await Promise.all(insertIntentPromises)
        }

        if (localVariables && localVariables.length > 0) {
          insertLocalVarPromises = localVariables.map(el => {
            if (!this.localVariables.find(local_var => local_var.name == el.name))
              return this.cloneVariable(el, this.selectedFlow.id, el.flowid)
            else return null
          })

          if (insertLocalVarPromises.length > 0) await Promise.all(insertLocalVarPromises)
        }

        // if (globalVariables && globalVariables.length > 0) {
        //   insertGlobalVarPromises = globalVariables.map(el => {
        //     // payload, pageid, oldpageid, flowid
        //     if (!this.globalVariables.find(global_var => global_var.name == el.name))
        //       return this.cloneGlobalVariable(
        //         el,
        //         this.selectedBot.pageid,
        //         el.pageid,
        //         this.selectedFlow.flowid
        //       )
        //     else return null
        //   })

        //   if (insertGlobalVarPromises.length > 0) await Promise.all(insertGlobalVarPromises)
        // }
      }

      window.location.reload()
      this.loadingExport = false
    },
    multipleUpdateNode(node) {
      var vm = this
      return new Promise(resolve => {
        vm.updateNode(true, {
          payload: cloneDeep(node),
          oncomplete: async intent => {
            resolve(intent)
          }
        })
      })
    },
    updateNode(isSilence, { payload, oncomplete }) {
      var vm = this
      vm.$store.dispatch('loading')

      return new Promise((resolve, reject) => {
        if (payload === undefined) {
          if (oncomplete) {
            oncomplete(null)
          }
          resolve()
        }
        var data = cloneDeep(payload)
        data.x = parseInt(data.x)
        data.y = parseInt(data.y)
        data.question = data.question ? data.question : ''
        if (typeof data.connected_intents != 'string')
          data.connected_intents = JSON.stringify(data.connected_intents)
        if (typeof data.answer != 'string') data.answer = JSON.stringify(data.answer)
        data.quick_reply = data.quick_reply ? data.quick_reply : ''

        api.editNode(data, function(error, response) {
          if (error) {
            console.error('updateNode:', error)
            if (!isSilence) {
              vm.flash('Save Unsuccessful: ' + error.message, 'error', {
                timeout: 3000
              })
            }
            vm.$store.dispatch('loading')
            reject(error)
          }

          if (response.responsecode == 200) {
            if (!isSilence) {
              vm.flash('Save Successful', 'success', {
                timeout: 3000
              })
            }
            vm.$store.dispatch('loading')
            var intentIndex = vm.intents.findIndex(el => {
              return el.id == payload.id
            })
            if (response.data && response.data.length > 0) {
              var intent = vm.convertSingleNode(response.data[0])

              if (intentIndex != -1) {
                vm.$set(vm.intents, intentIndex, intent)
              } else {
                vm.intents.push(intent)
              }
              vm.$nextTick(() => {
                if (oncomplete) {
                  oncomplete(intent)
                }
              })
            }
            resolve()
          } else {
            reject(response.responsecode)
          }
        })
        // } else {
        //   if (!isSilence) {
        //     vm.flash('Save Unsuccessful ', 'error', {
        //       timeout: 3000
        //     })
        //   }
        //   reject()
        // }
      })
    },
    exportFlow() {
      this.loadingExport = true
      try {
        var data = {
            globalVariables: this.globalVariables,
            localVariables: this.localVariables,
            flows: this.intents
          },
          fileName = 'export-flow.json'

        var a = document.createElement('a')
        var json = JSON.stringify(data),
          blob = new Blob([json], { type: 'octet/stream' }),
          url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = fileName
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error(error)
      }
      this.loadingExport = false
    },
    cloneVariable(payload, flowid, oldflowid) {
      return new Promise((resolve, reject) => {
        var data = cloneDeep(payload)
        delete data.id
        data.name = data.name.replace(`flow${oldflowid}.`, `flow${flowid}.`)
        data.flowid = flowid

        api.addVariable(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data && response.data.length > 0) {
            resolve({ ...response.data[0], oldid: payload.id })
          } else {
            reject()
          }
        })
      })
    },
    cloneGlobalVariable(payload, pageid, oldpageid, flowid) {
      return new Promise((resolve, reject) => {
        var data = cloneDeep(payload)
        delete data.id
        data.name = data.name.replace(`${oldpageid}.`, `${pageid}.`)
        data.flowid = flowid

        api.addVariable(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data && response.data.length > 0) {
            resolve({ ...response.data[0], oldid: payload.id })
          } else {
            reject()
          }
        })
      })
    },
    getChildren(type) {
      const flows = []
      // template

      for (const flow of this.filterFlows) {
        if ((flow.template ? flow.template.toLowerCase() : flow.template) !== type) continue

        flows.push({
          ...flow,
          name: flow.flowname,
          id: flow.id
        })
      }

      return flows.sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
    },
    getName(name) {
      if (!name) return null
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    updateRoute: function() {
      try {
        if (
          this.selectedFlow == null ||
          !this.$route.fullPath.includes(`flowid=${this.selectedFlow.id}`)
        ) {
          this.$router.push({
            name: 'flow',
            path: '/flow',
            query: {
              flowid: this.selectedFlow.id || null
            }
          })
          this.routeValue = JSON.stringify(this.$route.query)
        }
      } catch (error) {}
    },
    onResize() {
      var width = window.innerWidth
      var height = window.innerHeight

      var appHeader = document.getElementById('app_header')
      var sidebarMenu = document.getElementById('sidebar_menu .v-navigation-drawer--open')

      this.maxWidth = width - (sidebarMenu ? sidebarMenu.clientWidth : 0)
      this.maxHeight = height - (appHeader ? appHeader.clientHeight : 0) - 2 - 60
    },
    async addNewFlow() {
      var vm = this

      var result = await vm.$validator.validateAll()
      if (!result) {
        vm.goToErrorInput()
        // do stuff if not valid.
        // console.log(this.$validator.errors.items)
        return false
      }

      var data = {
        flowname: vm.flowname,
        template: vm.flowtemplate,
        x: 0,
        y: 0,
        zoom: 1,
        adminid: vm.$store.state.userid,
        pageidlist: vm.selectedBot.pageid,
        description: vm.description,
        ispublic: vm.isPublic == 'true' || false
      }
      vm.loadingAddFlow = true
      try {
        await api.addFlowDetail(data)

        await vm.$store.dispatch('loadFlowList')
        if (vm.flows.length > 0) {
          vm.$store.dispatch('setFlowID', vm.flows[0])
        }
        vm.flowname = ''
        vm.flowtemplate = ''
        vm.showAddFlow = false
        vm.loadingAddFlow = false
      } catch (error) {
        console.error(error)
        vm.showAddFlow = false
        vm.loadingAddFlow = false
      }
    },
    onClickFlow(flow) {
      this.$store.dispatch('setFlowID', flow)
      this.showFlow = true
    }
  },
  watch: {
    selectedFlow: function(newVal, oldVal) {
      if (newVal != oldVal) this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped>
.flow {
  cursor: pointer;
  border-radius: 5px;
  &:hover {
    background: rgb(221, 221, 221);
  }
  &:active {
    background: rgb(238, 238, 238);
  }
  &.active {
    background: rgb(207, 207, 207);
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/flow/Flows.vue